import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PriceBreakdownModel } from '../models/QuickSaleModel';
import { formatEuro } from '../utils/quickSaleFormat';

type Props = {
  price: PriceBreakdownModel | null;
};

/** Original price struck through, the discount and the food total in bold. */
const PriceBreakdown: FC<Props> = ({ price }) => {
  const intl = useIntl();

  if (!price || price.net_products === null) {
    return <span className="text-muted">-</span>;
  }

  const hasDiscount = !!price.discounts && price.discounts < 0;

  return (
    <span className="d-inline-flex align-items-center gap-2 text-nowrap">
      {hasDiscount && (
        <>
          <del className="text-muted" data-testid="price-original">
            {formatEuro(intl, price.products)}
          </del>
          <span
            className="badge badge-light-success"
            title={formatEuro(intl, price.discounts)}
          >
            -{intl.formatNumber(price.discount_pct)}%
          </span>
        </>
      )}
      <strong data-testid="price-total">
        {formatEuro(intl, price.net_products)}
      </strong>
    </span>
  );
};

export { PriceBreakdown };
